import { render } from "./ModuleTabbarTab.vue?vue&type=template&id=42e250b8&scoped=true"
import script from "./ModuleTabbarTab.vue?vue&type=script&lang=js"
export * from "./ModuleTabbarTab.vue?vue&type=script&lang=js"

import "./ModuleTabbarTab.vue?vue&type=style&index=0&id=42e250b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e250b8"]])

export default __exports__